import React, { createContext, useContext, useEffect, useState } from "react";
import { useUser } from "./UserContext";
import { getAuthorizedUsersList } from "../services/iqApiV2";


const AuthorizedUserContext = createContext({
  isAuthorized: false,
  isAuthLoading: true,
});

export const AuthorizedUserProvider = ({ children }) => {
  const { user } = useUser();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  useEffect(() => {
    const fetchAuthorization = async () => {
      if (!user?.id) {
        setIsAuthorized(false);
        setIsAuthLoading(false);
        return;
      }

      try {
        const response = await getAuthorizedUsersList();
        // assuming the response is an array of user objects or IDs
        const authorizedIds = response?.data || response; 

        const found = authorizedIds.some((item) => {
          // handles both array of IDs and array of objects
          return item === user.id || item?.id === user.id;
        });

        setIsAuthorized(found);
      } catch (err) {
        console.error("Authorization fetch failed:", err);
        setIsAuthorized(false);
      } finally {
        setIsAuthLoading(false);
      }
    };

    fetchAuthorization();
  }, [user?.id]);

  return (
    <AuthorizedUserContext.Provider value={{ isAuthorized, isAuthLoading }}>
      {children}
    </AuthorizedUserContext.Provider>
  );
};

export const useAuthorizedUser = () => useContext(AuthorizedUserContext);
